import React, { useState, useEffect } from 'react';

import { Dialog, Classes, Button, InputGroup, HTMLSelect, Label } from '@blueprintjs/core';

import API from '../Utilities/API';

import CountrySelect from '../Country/CountrySelect';
import CountryLanguage from '../Utilities/CountryLanguage';

export default ({ text, onHide }) => {

    const [keyword, setKeyword] = useState(text);
    const [translation, setTranslation] = useState('');
    const [type, setType] = useState('Person');
    const [country, setCountry] = useState('');
    const [language, setLanguage] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!text || text.length === 0) {
            var text = "";
            if (typeof window.getSelection != "undefined") {
                text = window.getSelection().toString();
            } else if (typeof document.selection != "undefined" && document.selection.type == "Text") {
                text = document.selection.createRange().text;
            }
            if (text && text.length > 0) setKeyword(text);
        }
    }, [])



    return (
        <>
            <Dialog
                title={'Request keyword insertion'}
                isOpen={true}
                usePortal
                className={'bp5-dark'}
                onClose={() => {
                    onHide && onHide();
                }}
            >
                <div className={Classes.DIALOG_BODY}>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10
                    }}>
                        <div style={{ flexGrow: 1, flexShrink: 0, flexBasis: '50%' }}>
                            <Label>Type</Label>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10
                    }}>
                        <div style={{ flexGrow: 1, flexShrink: 0, flexBasis: '50%' }}>
                            <HTMLSelect fill onChange={(e) => {
                                setType(e.target.value);
                                console.log('type', e.target.value);
                            }}>
                                <option value="Person">Person</option>
                                <option value="Company">Company</option>
                                <option value="City">City</option>
                                <option value="Country">Country</option>
                                <option value="Political Party">Political Party</option>
                                <option value="Institution">Institution</option>
                                <option value="Organization">Organization</option>
                                <option value="Media">Media</option>
                                <option value="Event">Event</option>
                                <option value="Other">Other</option>
                                <option value="Generic">Generic word</option>
                                <option value="Project">Project</option>
                            </HTMLSelect>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        marginTop: 20
                    }}>
                        <div style={{ flexGrow: 1, flexShrink: 0, flexBasis: '50%' }}>
                            <Label>Country</Label>
                        </div>
                        <div style={{ flexGrow: 1, flexShrink: 0, flexBasis: '50%' }}>
                            <Label>Language</Label>
                        </div>
                    </div>

                    <CountryLanguage
                        countrySelect={(ctr) => {
                            setCountry(ctr);
                        }}
                        languageSelect={(ctr) => {
                            setLanguage(ctr);
                        }}
                        hideType
                        hideCategory
                    />

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        marginTop: 20
                    }}>
                        <div style={{ flexGrow: 1, flexShrink: 0, flexBasis: '50%' }}>
                            <Label>Title</Label>
                        </div>
                        <div style={{ flexGrow: 1, flexShrink: 0, flexBasis: '50%' }}>
                            <Label>Translation</Label>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10
                    }}>
                        <div style={{ flexGrow: 1, flexShrink: 0 }}>
                            <InputGroup
                                placeholder={'Enter keyword'}
                                value={keyword}
                                dir='auto'
                                onChange={(e) => {
                                    setKeyword(e.target.value);
                                }}
                            />
                        </div>
                        <div style={{ flexGrow: 1, flexShrink: 0 }}>
                            <InputGroup
                                placeholder={'Enter translation'}
                                value={translation}
                                onChange={(e) => {
                                    setTranslation(e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        marginTop: 20
                    }}>
                        <div style={{ flexGrow: 1, flexShrink: 0 }}>
                            <Label>Notes</Label>
                        </div>
                    </div>

                    <textarea
                        rows={10}
                        style={{
                            width: '100%',
                            marginTop: 10
                        }}
                        className={Classes.INPUT}
                        placeholder={'Write your description, include links, etc.'}
                        onChange={(e) => {
                            setDescription(e.target.value);
                        }}
                    >{description}</textarea>
                </div>
                <div className={Classes.DIALOG_FOOTER} style={{ textAlign: 'right' }}>
                    <Button large intent={'primary'} onClick={() => {
                        if (window.confirm('Send keyword?')) {
                            API.RequestKeyword(keyword, description, type, country, translation, language).then(() => {
                                onHide && onHide();
                            });
                        }
                    }}>Save</Button>
                    <Button large onClick={() => {
                        if (keyword.length === 0 && translation.length === 0) {
                            onHide && onHide()
                        } else {
                            if (window.confirm('Close without sending?')) {
                                onHide && onHide()
                            }
                        }
                    }}>Close</Button>
                </div>
            </Dialog>
        </>
    )

}